import { render, staticRenderFns } from "./PriceCalculatorResult.vue?vue&type=template&id=71b235cc&"
import script from "./PriceCalculatorResult.vue?vue&type=script&lang=js&"
export * from "./PriceCalculatorResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports